"use client";

import { createContext, useContext, useMemo, useState } from "react";

/**
 * @typedef {object} AuthStateContextValue
 * @prop {boolean} authenticated
 * @prop {import("react").Dispatch<import("react").SetStateAction<boolean>>} setAuthenticated
 */

const AuthStateContext = createContext(
  /** @type {AuthStateContextValue | null} */ (null),
);

/**
 * @typedef {object} Props
 * @prop {boolean} initialAuthenticated
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
export function AuthStateProvider({ initialAuthenticated, children }) {
  const [authenticated, setAuthenticated] = useState(initialAuthenticated);

  const value = useMemo(() => {
    const value = {
      authenticated,
      setAuthenticated,
    };
    return value;
  }, [authenticated]);

  return (
    <AuthStateContext.Provider value={value}>
      {children}
    </AuthStateContext.Provider>
  );
}

export function useAuthState() {
  const value = useContext(AuthStateContext);

  if (value === null) {
    throw new Error("useAuthState must be used within an AuthProvider");
  }

  return value;
}
